// Gate de tela dos módulos de produto (Meet/Campanhas/Marketing R$47/mês,
// Ligações R$197/mês): no mount, consulta o estado do módulo e — se a conta
// não tem — abre o paywall BLOQUEANTE (fechar volta pra tela anterior).
// Grandfather/override nunca veem nada.
import { onMounted } from 'vue';
import { emitter } from 'shared/helpers/mitt';
import BillingAPI from 'dashboard/api/billing';

export function useModuleGate(moduleKey) {
  onMounted(async () => {
    try {
      const { data } = await BillingAPI.getModules();
      if (data?.modules?.[moduleKey]?.enabled === false) {
        emitter.emit('showModulePaywall', {
          module: moduleKey,
          blocking: true,
        });
      }
    } catch {
      // sem dado de módulo (erro transitório): não bloqueia a tela
    }
  });
}
